"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const v4_1 = require("zod/v4");
exports.TaskSchema = tape_sanitizer_1.Asset2JsonTransformationSchema.omit({
    srcDataTape: true,
}).extend({
    operation: v4_1.z.literal('asset2json'),
    srcArtifactSlug: v4_1.z.string(),
});
exports.UiConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
});
exports.nodeType = 'operation_asset2json';
//# sourceMappingURL=types.js.map